import { integrationTypeSchema } from '../../accounts/public-api';
import { z } from 'zod/v4';

export const copilotRequestSchema = z.object({
  ip: z.nullable(z.string()),
  accountId: z.nullable(z.number()),
  deviceId: z.nullable(z.string()),
  driverId: z.nullable(z.string()),
  operation: z.nullable(z.string()),
  revision: z.nullable(z.string()),
  request: z.nullable(z.string()),
  response: z.nullable(z.string()),
  compositionTimestamp: z.nullable(z.string()),
  requestTimestamp: z.nullable(z.string()),
  responseTimestamp: z.nullable(z.string()),
  responseLength: z.optional(z.number()),
  onRoadEventType: z.nullable(z.string()),
  offset: z.array(z.union([z.string(), z.number()])),
  partnerType: integrationTypeSchema.optional(),
  outOfRouteEventType: z.nullable(z.string()),
});

export type CopilotRequest = z.infer<typeof copilotRequestSchema>;
